// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2RS3n","amount":"Amount_amount__1rIT2","tip":"Amount_tip__2bd2l","tipHeader":"Amount_tipHeader__v_Pua","tipsWrap":"Amount_tipsWrap___I0mj"};